import produce from 'immer';
import create from 'zustand';

const useContentFormatTypeStore = create(set => ({
  contentFormatType: {
    id: null,
    name: null,
    slug: null,
    description: null,
  },
  errors: {},
  set: fn => set(produce(fn)),
}));

export default useContentFormatTypeStore;
